module.exports = __webpack_public_path__ + "img/frown-red-icon.5522d567.svg";